export default __webpack_public_path__ + "static/media/list-last.e0f705ae.svg";